
/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';
import { createOpenModalAction, createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { editConnectionPaymentTypes, deleteConnectionPaymentTypes } from 'state/connection-payment-types/actions';

const openPaymentModal = createOpenModalAction('EditPaymentTypesModal');
const closePaymentModal = createCloseModalAction('EditPaymentTypesModal');

export const startAddingPaymentTypes = (paymentTypeId, edits) => dispatch => {
    dispatch({
        type: actions.START_ADDING_PAYMENT_TYPES,
        payload: { paymentTypeId, edits }
    })
    dispatch(editConnectionPaymentTypes(paymentTypeId, edits));
    dispatch(openPaymentModal());
}

export const stopAddingPaymentTypes = () => dispatch => {
    dispatch({
        type: actions.STOP_ADDING_PAYMENT_TYPES
    })
    dispatch(closePaymentModal());
}

export const deletePaymentTypes = (paymentTypeId) => dispatch => {
    dispatch({
        type: actions.DELETE_PAYMENT_TYPES,
        payload: { paymentTypeId }
    })
    dispatch(deleteConnectionPaymentTypes(paymentTypeId));
    //props.successNotice('Deleted');
}

